import { render, staticRenderFns } from "./BaseParagraphe.vue?vue&type=template&id=9f63e42a&scoped=true"
import script from "./BaseParagraphe.vue?vue&type=script&lang=js"
export * from "./BaseParagraphe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f63e42a",
  null
  
)

export default component.exports